import { Component, ElementRef, input, OnInit, output, signal, viewChild } from '@angular/core';
import { UserInfo } from 'src/app/store/session/session.store';

export type AnnouncementPositionMode = 'fixed' | 'anchor';
export type AnnouncementPlacement = 'right' | 'left' | 'top' | 'bottom';

@Component({
  selector: 'app-small-feature-announcement',
  standalone: true,
  templateUrl: './small-feature-announcement.component.html',
  styleUrls: ['./small-feature-announcement.component.scss'],
  imports: [],
  host: {
    '(click)': 'onHostClick($event)',
    '[class.mode-fixed]': "positionMode() === 'fixed'",
    '[class.mode-anchor]': "positionMode() === 'anchor'",
    '[class.placement-right]': "placement() === 'right'",
    '[class.placement-left]': "placement() === 'left'",
    '[class.placement-top]': "placement() === 'top'",
    '[class.placement-bottom]': "placement() === 'bottom'",
  },
})
export class SmallFeatureAnnouncementComponent implements OnInit {
  featureKey = input<string>();
  title = input<string>();
  description = input.required<string>();
  badgeText = input.required<string>();
  soundSrc = input<string>();
  dealerCnpj = input<string>();
  userInfo = input<UserInfo>();
  positionMode = input<AnnouncementPositionMode>('fixed');
  placement = input<AnnouncementPlacement>('right');
  showCloseButton = input<boolean>(false);
  dismissed = output<void>();

  show = signal(false);

  private audioRef = viewChild<ElementRef<HTMLAudioElement>>('audioPlayer');

  ngOnInit() {
    if (this.showCloseButton()) {
      setTimeout(() => {
        this.show.set(true);
        this.playSound();
      }, 800);
      return;
    }

    const lastDismissed = localStorage.getItem(`announcement_${this.featureKey()}`);

    if (!lastDismissed || Date.now() - parseInt(lastDismissed, 10) > 24 * 60 * 60 * 1000) {
      setTimeout(() => {
        this.show.set(true);
        this.playSound();
      }, 800);
    }
  }

  dismiss(event?: MouseEvent) {
    event?.stopPropagation();
    event?.preventDefault();
    this.show.set(false);

    if (!this.showCloseButton()) {
      localStorage.setItem(`announcement_${this.featureKey()}`, Date.now().toString());
    }

    this.dismissed.emit();
  }

  onHostClick(event: MouseEvent) {
    event.stopPropagation();
  }

  private playSound() {
    const audio = this.audioRef()?.nativeElement;
    if (!audio) return;

    audio.currentTime = 0;
    audio.play().catch(() => {});
  }
}